module.exports = __webpack_public_path__ + "static/Monetize-Cross-Sell-e160fb86b8593df4346d434d1e1477c4.jpg";